import Button from '@components/button';
import Popup from '@components/popup';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';

import { useStore } from 'hooks/useStore';

import css from './MobileScreen.module.css';

type MobileScreenProps = {
  children: ReactNode;
  title: string;
  hasBackButton?: boolean;
  actions?: Actions;
};

type Actions = {
  [key in 'main' | 'second' | 'cancel']?: {
    onClick: () => void;
    text: string;
  };
};

const MobileScreen = ({ children, title, hasBackButton, actions }: MobileScreenProps) => {
  const {
    ui: {
      mobileScreens: { closeScreens, goBack },
    },
    app: { i18n },
  } = useStore();

  return (
    <Popup size="medium" onClose={closeScreens}>
      <Popup.Header backLinkContent={hasBackButton && i18n.common.back} onBackClick={goBack}>
        {title}
      </Popup.Header>
      <Popup.Content>{children}</Popup.Content>

      <Popup.Footer className={css.footer}>
        {Boolean(actions?.main) && (
          <Popup.ActionWrapper type="main">
            <Button fullWidth theme="primary" onClick={actions?.main?.onClick}>
              {actions?.main?.text}
            </Button>
          </Popup.ActionWrapper>
        )}

        {Boolean(actions?.second) && (
          <Popup.ActionWrapper type="second">
            <Button fullWidth onClick={actions?.second?.onClick}>
              {actions?.second?.text}
            </Button>
          </Popup.ActionWrapper>
        )}

        {Boolean(actions?.cancel) && (
          <Popup.ActionWrapper type="cancel">
            <button className="glz-link glz-is-large glz-is-primary" onClick={actions?.cancel?.onClick}>
              {actions?.cancel?.text}
            </button>
          </Popup.ActionWrapper>
        )}
      </Popup.Footer>
    </Popup>
  );
};

const connected = observer(MobileScreen);

export { connected as MobileScreen };
